import { useEffect } from 'react';

export const useDisableScrollWhenUseSlider = (slider: HTMLDivElement) => {
  useEffect(() => {
    if (!slider) return;

    const preventTouchMove = (e: TouchEvent) => e.preventDefault();

    const handleTouchStart = () => document.addEventListener('touchmove', preventTouchMove, { passive: false });

    const handleTouchEnd = () => document.removeEventListener('touchmove', preventTouchMove);

    slider.addEventListener('touchstart', handleTouchStart);
    slider.addEventListener('touchend', handleTouchEnd);

    return () => {
      slider.removeEventListener('touchstart', handleTouchStart);
      slider.removeEventListener('touchend', handleTouchEnd);
    };
  }, [slider]);
};
